import React from 'react';
import Contact from '../components/Contact';
const ContactPage = () => {
  return (
    <>
      <div style={{ marginTop: '36px' }}>

        <Contact />
      </div>
    </>
  );
};

export default ContactPage;